import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection"
import StrategyBlock from "./strategyBlock";

export default function StrategySustainability() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        pb={20}
      >

        <SectionHeading
          title="Strategy sustainability" 
          />

        <center>
          <Box
            w={{ base: "full", md: "3xl", xl: "7xl" }}
            mt={10}>
            <SimpleGrid
              columns={{ base: 1, md: 1, xl: 2 }}>

              <StrategyBlock
                text1="Through strategic partnerships, collaborations, and a focus on social help, we will ensure that our initiative continues to make a positive and lasting impact on the lives of those we support."
              />

              <StrategyBlock
                text1="Join us in transforming lives through technology."
                text2="Together, we can challenge barriers and create an inclusive future full of opportunity for all."
              />

            </SimpleGrid>
          </Box>
        </center>

      </Box>
    </>
  );
}